// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as WorkSpaceContext from "../../../../../library/work-space/WorkSpaceContext.bs.js";
import * as TertiaryButton$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/components/generic/buttons/TertiaryButton.bs.js";

function RaiseTicketSuccessPage(Props) {
  var ticket_response = Props.ticket_response;
  var workspaceDispatch = WorkSpaceContext.useWorkSpace(undefined);
  return React.createElement("div", {
              className: "c-create-ticket-success-page"
            }, "Ticket created successfully", React.createElement(TertiaryButton$Catalyst.make, {
                  onSelectCB: (function (param) {
                      return Curry._2(workspaceDispatch.addTab, {
                                  TAG: /* Ticket */43,
                                  case_number: ticket_response.ticket_id
                                }, false);
                    }),
                  children: "View ticket"
                }));
}

var make = RaiseTicketSuccessPage;

export {
  make ,
  
}
/* react Not a pure module */
